module.exports = __webpack_public_path__ + "front/img/10_6.8dcaa247.png";